import { useEffect, useState } from 'react'
import axios from 'axios'
import Loader from './../components/Loader';
import { Table } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import { api } from "../services/config"


function TasksStatusScreen() {
    const [tasks, setTasks] = useState([])
    const [exports, setExports] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingExports, setLoadingExports] = useState(false)

    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState
    const [refresh, setRefresh] = useState(false)


    useEffect(() => {
        async function fetchTasksStatus() {
            setLoading(true)
            await axios.get(api.project + projectId + '/tasks')
                .then(res => {
                    setTasks(res.data)
                    setLoading(false)
                })
                .catch(
                    function (error) {
                        setLoading(false)
                        return Promise.reject(error)
                    }
                )
        }
        async function fetchExports() {
            setLoadingExports(true)
            await axios.get(api.project + projectId + '/export/')
                .then(res => {
                    setExports(res.data)
                    setLoadingExports(false)
                })
                .catch(
                    function (error) {
                        setLoadingExports(false)
                        return Promise.reject(error)
                    }
                )
        }
        fetchTasksStatus()
        fetchExports()
    }, [projectId, refresh])

    const refreshAfterDownlaod = () => {
        window.setTimeout(() => {
            setRefresh(!refresh)
        }, 500)
    }

    return (
        <div className="container-element container text-center mt-5">
            <h4 className="mb-3">Statut des tâches</h4>
            {(loading || loadingExports)
                ? <Loader />
                : <Table striped bordered hover responsive className='table-sm'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Utilisateur</th>
                            <th>Type de traitement</th>
                            <th>Nom du fichier</th>
                            <th>Date de début</th>
                            <th>Date de fin</th>
                            <th>Status</th>
                            <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map(task => (
                            <tr key={task.id}>
                                <td>{task.id}</td>
                                <td>{task?.author?.username}</td>
                                <td>
                                    {
                                        (task.type === "UP-YATEA") && <p>Import YATEA</p>
                                    }
                                    {
                                        (task.type === "UP-TSUIT") && <p>Import TermSuite</p>
                                    }
                                    {
                                        (task.type === "UP-LISTS") && <p>Import de liste à plat</p>
                                    }
                                    {
                                        (task.type === "UP-DOC") && <p>Import de documents</p>
                                    }
                                    {
                                        (task.type === "UP-SKOS") && <p>Import SKOS</p>
                                    }
                                    {
                                        (task.type === "FUSION") && <p>Fusion</p>
                                    }
                                    {
                                        (task.type === "FILTER") && <p>Filtre</p>
                                    }
                                    {
                                        (task.type === "EXPORT") && <p>Export</p>
                                    }
                                </td>
                                <td>{task.file.name}</td>
                                <td>{task.date_created.substring(0, 10)} {task.date_created.substring(11, 19)}</td>
                                <td>
                                    {task.status === "SUCCESS" || task.status === "FAILURE"
                                        ? `${task.date_done.substring(0, 10)} ${task.date_done.substring(11, 19)}`
                                        : ""
                                    }
                                </td>
                                <td>
                                    {(() => {
                                        switch (task.status) {
                                            case "SUCCESS": return "SUCCÈS"
                                            case "FAILURE": return "ÉCHEC";
                                            case "PROGRESS": return "En cours";
                                            case "STARTED": return "En cours";
                                            default: return task.status;
                                        }
                                    })()}
                                </td>
                                {(task.status === 'SUCCESS')
                                    ? <td>
                                        {
                                            (task.type === "UP-YATEA") && task.results && <p>{task.results.term} termes ajoutés</p>
                                        }
                                        {
                                            (task.type === "UP-TSUIT") && task.results && <p>{task.results.term} termes ajoutés</p>
                                        }
                                        {
                                            (task.type === "UP-LISTS") && task.results && <p>{task.results.term} termes ajoutés</p>
                                        }
                                        {
                                            (task.type === "UP-DOC") && task.results && <p>{task.results.added} documents ajoutés</p>
                                        }
                                        {
                                            (task.type === "UP-SKOS") && task.results && <p>{task.results.semantic} classes sémantiques ajoutées</p>
                                        }
                                        {
                                            (task.type === "FUSION") && task.results && <p>{`${task.results.distinct} termes distincts ${task.results.replaced} termes remplacés !`}</p>
                                        }
                                        {
                                            (task.type === "FILTER") && task.results && <p>{`${task.results.rejected} termes rejetés !`}</p>
                                        }
                                        {
                                            (task.type === "EXPORT") && task.results && <>
                                                <p>
                                                    {`${task.results.message_fr}`}
                                                </p>

                                                {renderFileStatus(exports, task, projectId, refreshAfterDownlaod)}
                                            </>
                                        }
                                    </td>
                                    : (task.status === 'FAILURE') ? <td>{task?.results?.exc_fr || task?.results?.exc_message?.toString()}</td> : <td></td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </Table>
            }
        </div>
    )
}

export default TasksStatusScreen

const renderFileStatus = (exports, task, projectId, refreshAfterDownlaod) => {
    const filteredExports = exports.filter((item) => item.task === task.task.id);
    return <>
        {filteredExports.map((item) => (
            <a
                href={`${api.project}${projectId}/export/${item.id}`}
                download
                onClick={refreshAfterDownlaod}
            >
                Télécharger le fichier
            </a>
        ))}
        {!filteredExports.length && task.status === "SUCCESS" && (
            <p style={{ color: "#A8A8A8" }}>Fichier téléchargé !</p>
        )}
    </>
}